// =============================================================================
// Solution Types
// =============================================================================

export const SOLUTION_TYPES = [
  { value: 'brute_force' as const, label: 'Brute Force' },
  { value: 'acceptable' as const, label: 'Acceptable' },
  { value: 'optimal' as const, label: 'Optimal' },
] as const

export type SolutionType = (typeof SOLUTION_TYPES)[number]['value']

// =============================================================================
// Difficulty Levels
// =============================================================================

export const DIFFICULTY_LEVELS = [
  { value: 'Easy', label: 'Easy', color: 'text-emerald-400' },
  { value: 'Medium', label: 'Medium', color: 'text-amber-400' },
  { value: 'Hard', label: 'Hard', color: 'text-rose-400' },
] as const

export type DifficultyLevel = (typeof DIFFICULTY_LEVELS)[number]['value']

// =============================================================================
// Difficulty selector (question modals) — includes an Unassigned option
// =============================================================================

export const DIFFICULTIES = ['', 'Easy', 'Medium', 'Hard'] as const
export type Difficulty = (typeof DIFFICULTIES)[number]

export const DIFFICULTY_LABELS: Record<Difficulty, string> = {
  '': 'Unassigned',
  Easy: 'Easy',
  Medium: 'Medium',
  Hard: 'Hard',
}
